<template>
  <div>
    <v-data-table
      dense
      dark
      hide-default-footer
      :headers="tableHeader"
      :items="tableItems"
      :loading="loading"
      :show-select="selectable"
      :single-select="selectable"
      :item-key="chave"
      :height="height"
      :disable-sort="disableSort"
      :multi-sort="multiSort"
      :must-sort="mustSort"
      :items-per-page="itensPerPage"
      :item-class="estiloLinha"
      no-data-text="Sem registros para exibir"
      loading-text="Carregando dados..."
      @item-selected="$emit('item-selected', $event)"
      @click:row="$emit('click:row', $event)"
      @dblclick:row="$emit('dblclick:row', $event)"
      @contextmenu:row="$emit('contextmenu:row', $event)"
    >
      <template
        v-for="(header, index) in this.tableHeader"
        v-slot:[`item.${header.value}`]="{ item }"
      >
        <div v-if="header.value === columnMasked" :key="index">
          {{ maskPlanoContas(item[header.value]) }}
        </div>
        <div
          v-else-if="header.value.indexOf(dateFieldNames) !== -1"
          :key="index"
        >
          <td>
            {{
              item[header.value]
                ? new Date(item[header.value] + '-03:00').toLocaleDateString(
                    'pt-BR'
                  )
                : null
            }}
          </td>
        </div>
        <div v-else-if="header.value === 'controls'" :key="index">
          <v-btn-toggle tile>
            <v-btn
              class="mr-1 rounded"
              fab
              x-small
              color="yellow darken-2"
              @click="goToRoute(item)"
            >
              <v-icon dark>mdi-pen</v-icon>
            </v-btn>
            <v-btn
              class="rounded"
              fab
              x-small
              color="red accent-4"
              @click="isDelete(item)"
            >
              <v-icon dark>mdi-delete</v-icon>
            </v-btn>
          </v-btn-toggle>
        </div>
        <div v-else :key="index">
          <td>{{ item[header.value] }}</td>
        </div>
      </template>
    </v-data-table>
    <confirm ref="confirm" v-model="confirm"></confirm>
  </div>
</template>

<script>
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
import { formatMaskPlanoContas } from '@/utils/utils'

export default {
  components: { Confirm },
  data: () => ({
    confirm: false,
    dateFieldNames: ['DATA'],
  }),
  props: {
    loading: {
      type: Boolean,
    },
    tableHeader: {
      type: Array,
    },
    tableItems: {
      type: Array,
    },
    selectedItem: {
      type: Object,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    itensPerPage: {
      type: Number,
      default: 10,
    },
    route: {
      type: String,
      default: null,
      required: true,
    },
    doDelete: {
      type: Function,
    },
    height: {
      type: Number,
    },
    chave: {
      type: String,
      default: 'CODIGO',
    },
    columnMasked: {
      type: String,
      default: null,
    },
    multiSort: {
      type: Boolean,
      default: false,
    },
    mustSort: {
      type: Boolean,
      default: false,
    },
    disableSort: {
      type: Boolean,
      default: false,
    },
    estiloLinha: {
      type: Function,
      default: null,
    },
  },
  methods: {
    async isDelete(item) {
      if (
        await this.$refs.confirm.open(
          'Exclusão',
          `Deseja relamente eliminar o registro ${item[this.chave]}?`,
          { color: 'red' }
        )
      ) {
        this.doDelete(item)
      } else {
        return
      }
    },
    goToRoute(item) {
      let id = item[this.chave]
      this.$router.push({ name: this.route, params: { id } })
    },
    maskPlanoContas(value) {
      return formatMaskPlanoContas(value, '#.##.##.###.###')
    },
  },
}
</script>

<style></style>
